import React, { useEffect, useMemo, useState } from 'react';
import { Button, Layout, Menu, message, Popover } from 'antd';
import { Link, Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Nav } from '../components/Nav/index';
import { Pay } from './Pay';
import PackageSelection from '../components/PackageSelection/PackageSelection';

export function Article() {
    const [qs] = useSearchParams();
    const [messageApi, contextHolder] = message.useMessage();
    let { pathname } = useLocation();
    const [showPay, setShowPay] = useState(qs.get('code') && qs.get('state'));

    const nav = useNavigate();

    return (
        <>
            {contextHolder}
            <Layout style={{ minHeight: '100vh', background: '#fff' }}>
                {showPay ? (
                    <Pay orderNo={qs.get('state')} code={qs.get('code')} state={qs.get('state')} />
                ) : (
                    <>
                        <Nav />
                        <PackageSelection />
                        <Outlet />
                    </>
                )}
            </Layout>
        </>
    );
}
